
import React, { useState, useRef, useEffect } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';

const Events = () =>{

  const [formData, setFormData] = useState({
    section_id: '',
    std_id: '',
    validtill: '',
    event_detail: '',
    speechText: "",
    fileType: "",
    savedFilename: "",
    pdfFile: null,
    // off_time_wkdays_even_to: '',
    // off_time_holi_fr: '',
    // off_time_holi_to: '',
  });


  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const [eventFiles, setEventFile] = useState([]);
  const [pdfURL, setPdfURL] = useState(null);
  const fileInputRef = useRef(null);
  // seteventFile


  // const [showModal, setShowModal] = useState(false);
  // const [showIntModal, setShowIntModal] = useState(false);
  // const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [showParkingModal, setShowParkingModal] = useState(false);

  useEffect(() => {

    if ("webkitSpeechRecognition" in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = false;

      recognition.onresult = (event) => {
        const transcript = event.results[event.results.length - 1][0].transcript;
        setFormData((prev) => ({
          ...prev,
          speechText: prev.speechText + " " + transcript
        }));
      };

      recognition.onerror = () => setIsListening(false);

      recognition.onend = () => {
        // When speech recognition fully stops
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    }

  }, []);

  const startListening = () => {
    if (!recognitionRef.current) {
      alert("Speech Recognition not supported");
      return;
    }
    setIsListening(true);
    recognitionRef.current.start();
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setIsListening(false);
  };

  const [isEditable, setIsEditable] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMoveSpeachToTextBox = async () => {

    setFormData(prev => ({
      ...prev,
      noticeText:
        prev.noticeText
          ? prev.noticeText + "\n" + prev.speechText   // append with new line
          : prev.speechText,                            // or replace if empty
      speechText: ""
    }));

  };
  const handleEmptySpeechText = async () => {

    const confirmClear = window.confirm("Sure you want to move clear Speech Text ?");
    if (!confirmClear) return;

    setFormData(prev => ({
      ...prev,
      speechText: "",
    }));

  };
  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    setEventFile(e.target.files);

    // setFileName(file.name);

    const previewURL = URL.createObjectURL(file);
    setPdfURL(previewURL);

    setFormData(prev => ({
      ...prev,
      pdfFile: file
    }));
  };

    const handleSave = async () => {
      try {
        if (!formData.inst_name) {
          alert('Please enter Institute Name !');
          return;
        }
        else if (!formData.addr_1) {
          alert('Please enter Address line 1 !');
          return;
        }

        const isConfirmed = window.confirm("Sure you want to update the record ?");

        if (!isConfirmed) {
          return;
        }

        const response = await axios.post(`${BASE_URL}/api/update_mst_institutes`, formData);

        if (response.data.message === '1') {
          alert('Institute details updated successfully !');
        }

        // setIsEditable(false);
      }
      catch (error) {
        alert('Institute update error !', error);

      }
    };

    return (
      <Container fluid className="p-3">
        <Card style={{ marginTop: '10px', padding: '15px' }}>
          <Row className="mb-3">

            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Section
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="section_id"
                  value={formData.section_id}
                // disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="">-- Select Section--</option>
                  <option value=""></option>

                </select>
              </InputGroup>
            </Col>
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Standard
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={formData.std_id}
                // disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="">-- Select Standard--</option>
                  <option value=""></option>
                </select>
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>
                  Valid Till Date
                </InputGroup.Text>
                <input
                  type="date"
                  style={{ textAlign: 'left' }}
                  className="form-control"
                  name="date"
                  value={formData.validtill}
                // disabled={!isEditable}
                // onChange={handleChange}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">

            <Col md={6}>
              <Form.Floating className="mb-3">
                <Form.Control
                  as="textarea"
                  style={{ height: "300px" }}
                  name="event_detail"
                  value={formData.event_detail}
                  onChange={handleChange}
                  placeholder="Type your notice here..."
                />
                <label className="fw-bold">Home Work Text</label>
                <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                  {formData.event_detail.length} characters
                </div>
              </Form.Floating>
            </Col>
            {/* Speech to Text Row */}
            <Col md={6}>
              <Form.Floating className="mb-3">
                <Form.Control
                  as="textarea"
                  style={{ height: "250px" }}
                  name="speechText"
                  value={formData.speechText}
                  onChange={handleChange}
                  readOnly
                  placeholder="Speak your notice here..."
                />
                <label className="fw-bold">Speech To Text</label>
              </Form.Floating>
              <div className="mt-2">
                {!isListening ? (
                  <Button variant="primary" onClick={startListening} className="me-2">
                    🎤 Start Listening
                  </Button>
                ) : (
                  <Button variant="danger" onClick={stopListening} className="me-2">
                    ⏹ Stop
                  </Button>
                )}
                <Button variant="primary" onClick={handleMoveSpeachToTextBox} disabled={formData.speechText.length === 0} className="me-2">
                  Move Text To Notice Text
                </Button>
                <Button variant="secondary" onClick={handleEmptySpeechText} disabled={formData.speechText.length === 0} className="me-2">
                  Empty Speech Text
                </Button>
              </div>
            </Col>

            {/* PDF Upload */}
            <Col md={6}>
              {/* <Form.Label>Select PDF File:</Form.Label> */}
              <Form.Control type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} id="formFileSm" />

              {pdfURL && (
                <div className="mt-3">
                  <h6>PDF Preview:</h6>
                  <iframe
                    src={pdfURL}
                    title="PDF Preview"
                    width="100%"
                    height="300px"
                    style={{ border: "1px solid #ccc" }}
                  ></iframe>
                </div>
              )}
            </Col>
          </Row>

          <Row className="mb-3 justify-content-end">
            <Col md="auto">
              <button className="btn btn-success" style={{ width: "100px" }} onClick={handleSave} disabled={!isEditable}>Save</button>
            </Col>
          </Row>
        </Card>

      </Container>
    );
};

  export default Events;
